import { render, staticRenderFns } from "./QNotification.vue?vue&type=template&id=71f17d16&scoped=true&"
import script from "./QNotification.vue?vue&type=script&lang=ts&"
export * from "./QNotification.vue?vue&type=script&lang=ts&"
import style0 from "./QNotification.vue?vue&type=style&index=0&id=71f17d16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f17d16",
  null
  
)

export default component.exports